/**
 * 全局枚举定义 - 前后端共用
 * 对齐 PRD 05-data-model.md 与 04-modules.md
 *
 * 任何枚举变更必须同步 PRD 与 DB migration。
 */
// ============ 主体 ============
/** 主体类型 */
export var MerchantType;
(function (MerchantType) {
    MerchantType["FACTORY"] = "FACTORY";
    MerchantType["SELLER"] = "SELLER";
    MerchantType["PLATFORM"] = "PLATFORM";
})(MerchantType || (MerchantType = {}));
/** 主体状态 */
export var MerchantStatus;
(function (MerchantStatus) {
    MerchantStatus["PENDING"] = "PENDING";
    MerchantStatus["ACTIVE"] = "ACTIVE";
    MerchantStatus["SUSPENDED"] = "SUSPENDED";
    MerchantStatus["REJECTED"] = "REJECTED";
})(MerchantStatus || (MerchantStatus = {}));
/** 银行虚拟子户类型 */
export var BankSubAccountType;
(function (BankSubAccountType) {
    BankSubAccountType["SELLER"] = "SELLER";
    BankSubAccountType["FACTORY"] = "FACTORY";
    BankSubAccountType["PLATFORM_POOL"] = "PLATFORM_POOL";
    BankSubAccountType["PLATFORM_REVENUE"] = "PLATFORM_REVENUE";
})(BankSubAccountType || (BankSubAccountType = {}));
// ============ 合作关系 ============
/** 合作关系状态 */
export var PartnershipStatus;
(function (PartnershipStatus) {
    PartnershipStatus["NEGOTIATING"] = "NEGOTIATING";
    PartnershipStatus["ACTIVE"] = "ACTIVE";
    PartnershipStatus["EXPIRED"] = "EXPIRED";
    PartnershipStatus["TERMINATED"] = "TERMINATED";
})(PartnershipStatus || (PartnershipStatus = {}));
// ============ 订单 ============
/** 电商平台来源 */
export var SourcePlatform;
(function (SourcePlatform) {
    SourcePlatform["DOUYIN"] = "DOUYIN";
    SourcePlatform["PINDUODUO"] = "PINDUODUO";
    SourcePlatform["KUAISHOU"] = "KUAISHOU";
})(SourcePlatform || (SourcePlatform = {}));
/** 订单状态 - 业务视角只有两种：支付成功 / 退款成功。
 *  发货/分账/开票是 PAID 订单上的处理动作，完成信号存在各自表里，不改变订单状态。 */
export var OrderStatus;
(function (OrderStatus) {
    OrderStatus["PAID"] = "PAID";
    OrderStatus["REFUNDED"] = "REFUNDED";
})(OrderStatus || (OrderStatus = {}));
/** 订单终态（不可回退） */
export const ORDER_TERMINAL_STATES = new Set([
    OrderStatus.REFUNDED,
]);
// ============ 分账 ============
/** 分账状态 - 见 PRD 05 §3.2（6 态） */
export var SettlementStatus;
(function (SettlementStatus) {
    SettlementStatus["PENDING"] = "PENDING";
    SettlementStatus["EXECUTING"] = "EXECUTING";
    SettlementStatus["SUCCESS"] = "SUCCESS";
    SettlementStatus["FAILED"] = "FAILED";
    SettlementStatus["REVERSING"] = "REVERSING";
    SettlementStatus["REVERSED"] = "REVERSED";
})(SettlementStatus || (SettlementStatus = {}));
/** 抽佣来源（从谁那里扣平台抽佣） */
export var FeeFrom;
(function (FeeFrom) {
    FeeFrom["FROM_FACTORY"] = "FROM_FACTORY";
    FeeFrom["FROM_SELLER"] = "FROM_SELLER";
    FeeFrom["SHARED"] = "SHARED";
})(FeeFrom || (FeeFrom = {}));
// ============ 发票（双票模型） ============
/**
 * 发票类别 - 双票核心
 * - GOODS: 商品票，工厂→消费者，13%
 * - SERVICE_FEE: 服务费票，商家→工厂，6%
 */
export var InvoiceCategory;
(function (InvoiceCategory) {
    InvoiceCategory["GOODS"] = "GOODS";
    InvoiceCategory["SERVICE_FEE"] = "SERVICE_FEE";
})(InvoiceCategory || (InvoiceCategory = {}));
/** 发票类型（正票/红冲） */
export var InvoiceType;
(function (InvoiceType) {
    InvoiceType["NORMAL"] = "NORMAL";
    InvoiceType["RED"] = "RED";
})(InvoiceType || (InvoiceType = {}));
/** 发票状态 - 见 PRD 05 §3.3（6 态） */
export var InvoiceStatus;
(function (InvoiceStatus) {
    InvoiceStatus["NOT_ISSUED"] = "NOT_ISSUED";
    InvoiceStatus["ISSUING"] = "ISSUING";
    InvoiceStatus["ISSUED"] = "ISSUED";
    InvoiceStatus["FAILED"] = "FAILED";
    InvoiceStatus["RED_FLUSHING"] = "RED_FLUSHING";
    InvoiceStatus["RED_FLUSHED"] = "RED_FLUSHED";
})(InvoiceStatus || (InvoiceStatus = {}));
/** 发票销售方角色（冗余 issuer 角色，便于查询） */
export var IssuerRole;
(function (IssuerRole) {
    IssuerRole["FACTORY"] = "FACTORY";
    IssuerRole["SELLER"] = "SELLER";
})(IssuerRole || (IssuerRole = {}));
// ============ 物流 ============
/** 物流方向 */
export var LogisticsDirection;
(function (LogisticsDirection) {
    LogisticsDirection["FORWARD"] = "FORWARD";
    LogisticsDirection["RETURN"] = "RETURN";
})(LogisticsDirection || (LogisticsDirection = {}));
/** 物流状态 */
export var LogisticsStatus;
(function (LogisticsStatus) {
    LogisticsStatus["UPLOADED"] = "UPLOADED";
    LogisticsStatus["IN_TRANSIT"] = "IN_TRANSIT";
    LogisticsStatus["DELIVERED"] = "DELIVERED";
})(LogisticsStatus || (LogisticsStatus = {}));
// ============ 退款 ============
/** 退款阶段 */
export var RefundStage;
(function (RefundStage) {
    RefundStage["PRE_SETTLE"] = "PRE_SETTLE";
    RefundStage["POST_SETTLE"] = "POST_SETTLE";
})(RefundStage || (RefundStage = {}));
/** 退款状态 */
export var RefundStatus;
(function (RefundStatus) {
    RefundStatus["REQUESTED"] = "REQUESTED";
    RefundStatus["APPROVED"] = "APPROVED";
    RefundStatus["REVERSING"] = "REVERSING";
    RefundStatus["COMPLETED"] = "COMPLETED";
    RefundStatus["REJECTED"] = "REJECTED";
})(RefundStatus || (RefundStatus = {}));
// ============ 存证 ============
/** 存证实体类型 */
export var EvidenceEntityType;
(function (EvidenceEntityType) {
    EvidenceEntityType["CONTRACT"] = "CONTRACT";
    EvidenceEntityType["SETTLEMENT"] = "SETTLEMENT";
    EvidenceEntityType["INVOICE"] = "INVOICE";
    EvidenceEntityType["LOGISTICS"] = "LOGISTICS";
    EvidenceEntityType["ORDER"] = "ORDER";
    EvidenceEntityType["REFUND"] = "REFUND";
})(EvidenceEntityType || (EvidenceEntityType = {}));
/** 四流类型 */
export var FlowType;
(function (FlowType) {
    FlowType["CONTRACT_FLOW"] = "CONTRACT_FLOW";
    FlowType["FUND_FLOW"] = "FUND_FLOW";
    FlowType["INVOICE_FLOW"] = "INVOICE_FLOW";
    FlowType["LOGISTICS_FLOW"] = "LOGISTICS_FLOW";
})(FlowType || (FlowType = {}));
// ============ 角色（用于 demo auth / RBAC） ============
/** 操作员角色 */
export var Role;
(function (Role) {
    Role["SELLER"] = "SELLER";
    Role["FACTORY"] = "FACTORY";
    Role["ADMIN_REVIEWER"] = "ADMIN_REVIEWER";
    Role["ADMIN_FINANCE"] = "ADMIN_FINANCE";
    Role["ADMIN_COMPLIANCE"] = "ADMIN_COMPLIANCE";
    Role["ADMIN_SUPER"] = "ADMIN_SUPER";
    Role["TAX_OFFICER"] = "TAX_OFFICER";
})(Role || (Role = {}));
//# sourceMappingURL=enums.js.map